const supportPopupAuthor = document.getElementById("popup-support_author");
const closeButton = document.querySelector(".popup__close-button");
const openButton = document.getElementById("open-support-popup");
const textAreaValue = document.querySelector(".popup__text-area");
const announBar = document.querySelector(".announcement-bar");

function openPopup(a) {
  a.classList.add("popup_opened");
  textAreaValue.value = "";
  document.addEventListener("keydown", closeByEscape);
}

function closePopup(a) {
  a.classList.remove("popup_opened");
  document.removeEventListener("keydown", closeByEscape);
}

function closeByEscape(a) {
  "Escape" === a.key &&
    ((a = document.querySelector(".popup_opened")), closePopup(a));
}

function closeByOverlay(a) {
  a.target === a.currentTarget &&
    ((a = document.querySelector(".popup_opened")), closePopup(a));
}

if (closeButton) {
  closeButton.addEventListener("click", () => closePopup(supportPopupAuthor));
}

if (supportPopupAuthor) {
  supportPopupAuthor.addEventListener("click", closeByOverlay);
}

if (openButton) {
  openButton.addEventListener("click", () => openPopup(supportPopupAuthor));
}
